// extracted by mini-css-extract-plugin
module.exports = {"main":"LargeImageTextButton-module--main--2yOQc","image":"LargeImageTextButton-module--image--3CrcG","name":"LargeImageTextButton-module--name--2k0-8"};